export default "__VITE_ASSET__c57cb739__"